import DefaultElementNodeType from '../DefaultElementNodeType';
import {TECHNOLOGY_EVENT} from '../../metamodel/Concept';

export default class TechnologyEventNodeType extends DefaultElementNodeType {
	static get typeName() {
		return TECHNOLOGY_EVENT;
	}
}
